<template>
  <!-- NOTE (TEMPLATE) to show the dashboard of the researcher -->
  <div class="animated fadeIn">
    <b-jumbotron bg-variant="white" text-variant="dark">
      <template v-slot:lead>
        <h2>راهنمای استفاده از سامانه</h2>
        <hr />
        <p>
          به منظور استفاده هر چه بهتر از سامانه خواهشمند است ویدئو‌های زیر را
          مشاهده بفرمایید.
        </p>
        <ul>
          <li v-for="i in clips.filter((x) => x.role == role)" :key="i.name">
            <b-link @click="showGuideClipsModal(i.url)">{{ i.name }}</b-link>
          </li>
        </ul>

        <hr />
        <h4>
          <i
            class="fa fa-question-circle text-primary fa-flip-horizontal"
            dir="rtl"
            aria-hidden="true"
          ></i>
          &nbsp;<b-link
            href="https://api.biodcportal.com/setad/public/طرح%20تقسیم%20کار%20ملی%20زیست%20فناوری.pdf"
            target="blank"
            >راهنمای آشنایی با طرح تقسیم کار ملی زیست فناوری
          </b-link>
        </h4>
      </template>
    </b-jumbotron>

    <b-modal
      id="guideClips"
      ref="guideClips"
      header-bg-variant="light"
      class="text-center border-0"
      size="lg"
      centered
      hide-footer
    >
      <div>
        <b-embed type="video" aspect="16by9" controls
          ><source :src="urlSrc" type="video/mp4" />
        </b-embed>
      </div>
    </b-modal>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      profileStatus: "",
      minVer: 0,
      urlSrc: "",
      role: "",
      clips: [],
    };
  },

  methods: {
    showGuideClipsModal(i) {
      this.$bvModal.show("guideClips");
      this.urlSrc = i;
    },
    setClips() {
      this.clips = [
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher1.mp4",
          name: "راهنمای ثبت طرح تحقیقاتی",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher2.mp4",
          name: "راهنمای ثبت رساله دکتری",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher3.mp4",
          name: "راهنمای ثبت مقاله ",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher4.mp4",
          name: "راهنمای ثبت فرصت مطالعاتی",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher5.mp4",
          name: "نحوه پیگیری درخواست¬های ثبت شده",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher6.mp4",
          name: "راهنمای ثبت نشست تخصصی",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher7.mp4",
          name: "راهنمای ثبت پسادکتری",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher8.mp4",
          name: "راهنمای ثبت نخبه وظیفه",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher9.mp4",
          name: "راهنمای کنترل پروژه",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher10.mp4",
          name: "راهنمای ثبت پایان نامه کارشناسی ارشد",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher11.mp4",
          name: "راهنمای ورود و ویرایش پروفایل پژوهشگر",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/researcher12.mp4",
          name: "راهنمای ثبت گزارش خطا توسط پژوهشگر",
          role: "researcher",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/admin1.mp4",
          name: "راهنمای کامل ادمین",
          role: "admin",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/admin2.mp4",
          name: "راهنمای ورود به سامانه و ثبت سریع درخواست",
          role: "admin",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/admin3.mp4",
          name: "راهنمای بخش مدیریت افراد",
          role: "admin",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/admin4.mp4",
          name: "راهنمای بخش تنظیمات",
          role: "admin",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/admin5.mp4",
          name: "راهنمای بخش گزارش ها",
          role: "admin",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/admin6.mp4",
          name: "راهنمای نحوه بررسی درخواست ها",
          role: "admin",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/admin8.mp4",
          name: "کنترل پروژه",
          role: "admin",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/reviewer1.mp4",
          name: "نحوه ورود داور به سامانه",
          role: "referee",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/reviewer2.mp4",
          name: "راهنمای کامل کاربر داور",
          role: "referee",
        },
        // {
        //   url: this.baseUrl + "/setad/public/biodctutorials/university.mp4",
        //   name: "راهنمای کامل کاربر دانشگاه  ",
        //   role: "university",
        // },
        {
          url:
            this.baseUrl +
            "/setad/public/biodctutorials/universityComplete.mp4",
          name: "راهنمای کامل کاربر دانشگاه  ",
          role: "university",
        },
        {
          url: this.baseUrl + "/setad/public/biodctutorials/manager.mp4",
          name: "راهنمای کامل رئیس گروه",
          role: "manager",
        },
      ];
    },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.setClips();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
